import { useState } from "react";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function EmailVerifyBanner() {
  const { user } = useAuth();
  const [sent, setSent] = useState(false);
  if (!user || user.email_verified) { return null; }
  const resend = async () => {
    try { await api.post("/auth/verify-email/resend"); setSent(true); toast.success("Email de confirmation envoyé"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900 sm:px-6" data-testid="email-verify-banner">
      <MailWarning className="h-4 w-4" />Confirmez votre adresse {user.email} pour sécuriser votre compte.
      <button type="button" onClick={resend} disabled={sent} className="font-medium underline disabled:no-underline disabled:opacity-60" data-testid="email-verify-resend">{sent ? "Email envoyé" : "Renvoyer l'email"}</button>
    </div>
  );
}
